import { neighborsList } from '@moleculeone/draw';
import { V4 } from '@moleculeone/utils';

const wideDoubleFan = [(Math.PI * 2) / 3, (Math.PI * 4) / 3];
const narrowDoubleFan = [(Math.PI * 3) / 4, (Math.PI * 5) / 4];

function positionCandidates(mol, idx) {
  const rightVect = V4.vect(100, 0);
  const positions = mol.positions;
  const position = positions[idx];
  const dirs = neighborsList(mol, idx).map(([_bond, atom]) => V4.sub(positions[atom.idx], position));
  let newDirs;
  switch (dirs.length) {
    case 0:
      newDirs = [rightVect];
      break;
    case 1:
      newDirs = wideDoubleFan.map(angle => V4.rotZ(dirs[0], angle));
      break;
    case 2: {
      const dirCenter = V4.add.apply(
        null,
        dirs.map(v => V4.scale(v, 1.0 / V4.dot(v, v)))
      );
      newDirs = narrowDoubleFan.map(angle => V4.rotZ(dirCenter, angle));
      newDirs.push(V4.scale(dirCenter, -1));
      newDirs.push(V4.scale(dirs[0], -1));
      newDirs.push(V4.scale(dirs[1], -1));
      break;
    }
    default:
      newDirs = dirs.map(n => V4.scale(n, -1));
  }
  return newDirs.map(dir => V4.add(position, V4.normal(dir, 100)));
}

function minimalDistance(mol, position, ignoreIdx) {
  return Object.entries(mol.positions)
    .filter(([idx, _p]) => idx !== ignoreIdx)
    .reduce((acc, [_idx, p]) => Math.min(V4.dist(position, p), acc), Number.POSITIVE_INFINITY);
}

export function rankedCandidates(mol, idx) {
  const candidates = positionCandidates(mol, idx);
  const proximities = {};
  for (const candidate of candidates) {
    proximities[candidate] = minimalDistance(mol, candidate, idx);
  }
  candidates.sort((a, b) => proximities[b] - proximities[a]); // reverse order
  return candidates;
}
